import React, { useEffect, useState } from "react";
import axios from "axios";
import { imgUrl } from "../admin/adminApi";
import { useCart } from "../context/CartContext";
import { Button } from "./ui/button";
import { Sparkles } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const scrollToServices = () => document.getElementById("categories")?.scrollIntoView({ behavior: "smooth" });

const Banners = () => {
  const { addToCart } = useCart();
  const [banners, setBanners] = useState([]);
  useEffect(() => { axios.get(`${API}/banners`).then((r) => setBanners(r.data)).catch(() => {}); }, []);
  if (banners.length === 0) return null;

  const book = (b) => {
    if (b.combo_price > 0) {
      addToCart({ name: `${b.title} (Combo)`, price: b.combo_price, type: "package" });
    } else {
      scrollToServices();
    }
  };

  return (
    <section className="py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-12">
        <div className="grid md:grid-cols-2 gap-6">
          {banners.slice(0, 4).map((b) => {
            const combo = b.combo_price > 0;
            const worth = b.original_price || 0;
            return (
              <div key={b.id} className="relative rounded-3xl overflow-hidden min-h-[240px] flex items-center shadow-lg group">
                <img src={imgUrl(b.image)} alt={b.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/45 to-transparent" />
                <div className="relative p-7 md:p-9 max-w-sm">
                  <span className="inline-flex items-center gap-1.5 bg-accent text-white text-xs font-semibold px-3 py-1 rounded-full"><Sparkles className="w-3.5 h-3.5" /> Special Offer</span>
                  <h3 className="font-display text-2xl md:text-3xl font-extrabold text-white mt-3 leading-tight">{b.title}</h3>
                  <p className="text-white/85 text-sm mt-2">{b.subtitle}</p>
                  {combo && (
                    <div className="mt-3 text-white">
                      {b.services?.length > 0 && <p className="text-xs text-white/75">{b.services.length} services: {b.services.join(", ")}</p>}
                      <div className="flex items-baseline gap-2 mt-1">
                        <span className="text-2xl font-extrabold">₹{b.combo_price}</span>
                        {worth > 0 && <span className="line-through text-white/60 text-sm">₹{worth}</span>}
                        {worth > b.combo_price && <span className="bg-white/20 text-white text-[11px] font-bold px-2 py-0.5 rounded-full">Save ₹{worth - b.combo_price}</span>}
                      </div>
                    </div>
                  )}
                  <Button onClick={() => book(b)} className="mt-4 bg-white text-primary hover:bg-white/90 rounded-full px-6 h-10 font-bold">{combo ? "Grab Deal" : "Book Now"}</Button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Banners;
